import { ScrollView, View } from 'react-native';
import { Button, IconButton, Text, useTheme } from "react-native-paper";
import React, { useContext, useEffect, useReducer, useRef, useState } from "react";
import ReactToPrint from 'react-to-print';
import * as XLSX from "xlsx"
import Preferance from '../constants/Preferances';

import { MaterialIcons } from '@expo/vector-icons';
import Global from '../constants/global';
import { useSelector } from 'react-redux';

const pageStyle = `

  @media all {
    .pagebreak {
      display: none;
      page-break-after: always;
    }
  }

  @media print {
    .pagebreak {
      page-break-after: always;
    }
  }
`;
export default function SummarySheet({ navigation, route }) {
    const [value, setValue] = useState({ class: undefined, student: [], subjects: [], exam: undefined, tarij: 0, totalStudents: 0, attend: 0, pass: 0, fail: 0, ranklist: [], left: 0, year: "" })
    const pref = useContext(Preferance)
    const SummarySheet = useSelector(s => s.list.SummarySheet)

    const Page = ({ s, type }) => {
        return <div style={{ display: "flex", flexDirection: "column", pageBreakInside: "avoid", flex: 1 }}>
            <Text variant="displaySmall" style={{ textAlign: "center", marginTop: 30, padding: 10, fontWeight: "bold", flex: 1 }}>{"શ્રી ઠક્કરબાપા વિદ્યામંદિર"}</Text>
            <Text style={{ flex: 1, padding: 10, backgroundColor: "green", color: "white", textAlign: "center" }} variant="titleLarge">પરીક્ષાનું ગુણપત્રક - {SummarySheet?.examName} - વર્ષ {SummarySheet.year}</Text>
            <View style={{ flexDirection: "row", marginTop: 20, }}>
                <Text style={{ flex: 2, fontWeight: "900" }} variant="titleLarge">{SummarySheet?.className}  {SummarySheet?.div}</Text>
                <Text variant="titleLarge" style={{ textAlign: "center", flex: 2 }}>પરીક્ષાની તારીખ  __________</Text>
            </View>
            <View style={{ marginTop: 20, flexDirection: "row" }}>
                <View style={{ flexDirection: "row", flex: 2 }}>
                    <Text style={{}} variant="titleLarge">વિષય  </Text>
                    <Text style={{ fontWeight: "900", borderBottomWidth: 1 }} variant="titleLarge">{s?.name} </Text>
                </View>
                <View style={{ flexDirection: "row", flex: 1 }}>
                    <Text style={{}} variant="titleLarge">કુલગુણ  </Text>
                    <Text style={{ borderBottomWidth: 1, fontWeight: "900" }} variant="titleLarge">{s?.totalMarks}</Text>
                </View>
            </View>
            <View style={{ flexDirection: "row", marginTop: 30 }}>
                <RollSheet till={17} above={0} subject={s} theory={type} />
                <RollSheet till={34} above={18} subject={s} theory={type} />
                <RollSheet till={51} above={35} subject={s} theory={type} />
                <RollSheet till={68} above={52} subject={s} theory={type} />
                <RollSheet till={85} above={69} subject={s} theory={type} />
            </View>
            <View style={{ flexDirection: "row", marginTop: 10 }}>
                <View style={{ justifyContent: "center", alignItems: "center", margin: 5, flex: 1 }}>
                    <Text variant="titleLarge" style={{ textAlign: "center", fontWeight: "900" }}>{s.pass}</Text>
                    <Text variant="titleLarge" style={{ textAlign: "center", borderTopWidth: 1 }}>પાસ</Text>
                </View>
                <View style={{ justifyContent: "center", alignItems: "center", margin: 5, flex: 1 }}>
                    <Text variant="titleLarge" style={{ textAlign: "center", fontWeight: "900" }}>{s.fail}</Text>
                    <Text variant="titleLarge" style={{ textAlign: "center", borderTopWidth: 1 }}>નાપાસ </Text>
                </View>
                <View style={{ justifyContent: "center", alignItems: "center", margin: 5, flex: 1 }}>
                    <Text variant="titleLarge" style={{ textAlign: "center", fontWeight: "900" }}>{s.absent}</Text>
                    <Text variant="titleLarge" style={{ textAlign: "center", borderTopWidth: 1 }}>Absent</Text>
                </View>
                <View style={{ justifyContent: "center", alignItems: "center", margin: 5, flex: 1 }}>
                    <Text variant="titleLarge" style={{ textAlign: "center", fontWeight: "900" }}>{s.fail + s.pass + s.absent}</Text>
                    <Text variant="titleLarge" style={{ textAlign: "center", borderTopWidth: 1 }}>કુલ</Text>
                </View>
                <View style={{ justifyContent: "center", alignItems: "center", margin: 5, flex: 1 }}>
                    <Text variant="titleLarge" style={{ textAlign: "center", fontWeight: "900" }}>{Math.round((s.pass * 100) / (s.fail + s.pass))}%</Text>
                    <Text variant="titleLarge" style={{ textAlign: "center", borderTopWidth: 1 }}>ટકાવારી</Text>
                </View>
            </View>

            <View style={{ flexDirection: "row", marginTop: 40 }}>
                <Text variant="titleLarge" style={{ textAlign: "center" }}>તપાસનારની સહી </Text>
                <Text variant="titleLarge" style={{ flex: 2, textAlign: "center", borderBottomWidth: 1, borderStyle: "solid" }}> </Text>
                <Text variant="titleLarge" style={{ flex: 1, textAlign: "center" }}>તારીખ</Text>
                <Text variant="titleLarge" style={{ flex: 1, borderBottomWidth: 1, borderStyle: "solid" }}>{""}</Text>
            </View>

            <View style={{ flexDirection: "row", marginTop: 40 }}>
                <Text variant="titleLarge" style={{ textAlign: "center" }}>વર્ગ શિક્ષકની સહી </Text>
                <Text variant="titleLarge" style={{ flex: 2, textAlign: "center", borderBottomWidth: 1, borderStyle: "solid" }}> </Text>
                <Text variant="titleLarge" style={{ flex: 1, textAlign: "center" }}>તારીખ</Text>
                <Text variant="titleLarge" style={{ flex: 1, borderBottomWidth: 1, borderStyle: "solid" }}>{""}</Text>
            </View>
        </div>
    }
    const RollSheet = ({ till, above, subject, theory }) => {
        const russia = subject?.students?.filter(e => e?.roll <= till && e?.roll >= above)
        return <View>
            {russia.length > 0 &&
                <View style={{ alignItems: "center", justifyContent: "center", marginRight: 2 }}>
                    <View style={{ flexDirection: "row", alignSelf: "stretch", borderWidth: 1, borderStyle: "solid" }}>
                        <Text variant="titleMedium" style={{ backgroundColor: "#DCDCDC", width: 65, textAlign: "center", borderRightWidth: 1, fontWeight: "900", paddingTop: 2, paddingBottom: 2 }}>રોલ નં</Text>
                        <Text variant="titleMedium" style={{ width: 65, textAlign: "center", fontWeight: "900", paddingTop: 2, paddingBottom: 2 }}>ગુણ</Text>
                    </View>
                    <View style={{ flex: 1 }}>
                        {
                            russia.map(s => {

                                const st1 = { paddingBottom: 4, alignItems: "center", justifyContent: "center", width: 65 }
                                const st2 = { textAlign: "center", paddingTop: 2, paddingBottom: 2 }
                                const style1 = s?.style1 ? s?.style1 : {}
                                const style2 = s?.style2 ? s?.style2 : {}
                                const sty1 = { ...st1, ...style1 }
                                const sty2 = { ...st2, ...style2 }
                                return <View style={{ borderWidth: 1, flexDirection: "row", alignSelf: "stretch", borderStyle: "solid", height: 33 }}>
                                    <Text variant="titleMedium" style={{ alignSelf: "stretch", backgroundColor: "#DCDCDC", width: 65, textAlign: "center", borderRightWidth: 1, paddingTop: 2, paddingBottom: 2 }}>{s.roll}</Text>
                                    <View style={sty1}>
                                        <Text variant="titleMedium" style={sty2}>{s.value}</Text>
                                    </View>
                                </View>
                            })
                        }
                    </View>
                </View>
            }
        </View >
    }

    useEffect(() => {
        if (route.params) {
            let classStudents: [] = route.params.student
            let exam = route.params.exam
            let year = route.params.year
            let std = route.params.class
            let subjectList = route.params.subjects?.filter(f => f.totalMarks > 0)

            let consAttent = 0
            let tstudent = classStudents?.length
            let Oattend = 0
            let Opass = 0
            let Ofail = 0
            let Oleft = 0
            let Ototal = 0
            let Oabsent = 0
            let Onotprepared = 0
            classStudents.map((student, i) => {
                let result = student?.Summary
                if (result) {
                    result = { ...result }
                }
                if (result) {
                    result.seq = i
                    Ototal++
                    if (Global.isLeft(student, year)) {  //changed isLeft
                        Oleft++
                    } else {
                        if (result?.theory == "Absent") {
                            Oabsent++
                        } else {
                            if (Global.getResultStatus(result?.status) == "Pending") {
                                Onotprepared++
                            } else {
                                if (Global.getResultStatus(result?.status) == "Fail") {
                                    Ofail++
                                    Oattend++
                                }
                                if (Global.getResultStatus(result?.status) == "Pass") {
                                    Opass++
                                    Oattend++
                                }
                            }
                        }
                    }
                }
            })

            subjectList.map((s, i) => {
                let attend = 0
                let pass = 0
                let fail = 0
                let left = 0
                let total = 0
                let absent = 0
                let notprepared = 0
                classStudents.map(student => {

                    const id = Global.genSubId({ studentId: student.Summary.student.id, classId: std.id, examId: exam.name, year: year, subjectId: s.id })
                    const result = { ...student?.[id] }
                    if (result) {
                        result.seq = i
                        total++
                        if (Global.isLeft(student, year)) {
                            left++
                        } else {
                            if (result.theory == "Absent") {
                                absent++
                            } else {
                                if (Global.getResultStatus(result.status) == "Pending") {
                                    notprepared++
                                } else {
                                    if (Global.getResultStatus(result.status) == "Fail") {
                                        fail++
                                        attend++
                                    }
                                    if (Global.getResultStatus(result.status) == "Pass") {
                                        pass++
                                        attend++
                                    }
                                }
                            }
                        }
                    } else {
                        //console.log("resultn ot found", student)
                    }

                })
                s.attend = attend
                s.pass = pass
                s.fail = fail
                s.left = left
                s.total = total
                s.absent = absent
                s.pending = notprepared
                if (attend > consAttent) {
                    consAttent = attend
                }
            })
            const ranklist = classStudents?.filter(f => {
                const r = f?.Summary?.rank
                return r !== 0 && r !== undefined && r <= 5
            }).sort((a, b) => {
                const ar = a?.Summary.rank
                const br = b?.Summary?.rank
                if (ar && br) {
                    return (ar || 0) - (br || 0);
                } else if (ar || br) {
                    return !(ar) - !(br)
                } else {
                    return (ar || 0) - (br || 0);
                }
            })
            const pass = classStudents?.filter(f => Global.getResultStatus(f?.Summary?.status) == "Pass" && f.left !== true)?.length
            const fail = classStudents?.filter(f => Global.getResultStatus(f?.Summary?.status) == "Fail" && f.left !== true)?.length
            const left = classStudents?.filter(f => Global.isLeft(f, year))?.length
            const sheet = []
            classStudents.map(m => {
                const reg = { student: m, examObject: exam }
                reg.subject = subjectList
                sheet.push(reg)
            })
            setValue({
                year: year,
                sheet: sheet,
                subjects: subjectList,
                class: { ...route.params.class },
                student: classStudents,
                exam: { ...route.params.exam },
                tarij: route.params.tarij,
                totalStudents: tstudent,
                attend: consAttent,
                pass: pass,
                fail: fail,
                ranklist: ranklist,
                left: left,
                overAll: { pass: Opass, fail: Ofail, total: Ototal, absent: Oabsent, attend: Oattend }
            })
        }
    }, [route.params])

    const ref = useRef()
    const Row1 = ({ roll, gr, name, title, left }) => {
        const tt = title ? { textAlign: "center" } : { fontSize: 10 }
        return <><div style={{ textAlign: "center", display: "flex", width: 30, maxWidth: 30, borderWidth: 1, borderStyle: "solid" }}>{roll}</div>
            <div style={{ width: 40, maxWidth: 40, borderWidth: 1, borderStyle: "solid", textAlign: "center" }}>{gr}</div>
            <div style={{ width: 150, maxWidth: 150, borderWidth: 1, borderStyle: "solid", ...tt, textDecorationLine: left == true ? 'line-through' : "" }}>{name}</div></>
    }

    const Row2 = ({ value, title, status }) => {
        const tt = title ? { fontSize: 10 } : {}
        return <div style={{ width: 45, maxWidth: 45, borderWidth: 1, borderStyle: "solid", justifyContent: "center", alignItems: "center" }}>
            <div variant={"titleSmall"} style={{
                textAlign: "center", ...tt,
                textDecoration: (status == "Fail" && value !== "Ab") ? "underline" : "none",
                color: (status == "Fail" && value !== "Ab") ? "red" : undefined
            }}> {value}</div>
        </div>
    }

    const Row3 = ({ v1, v2, v3 }) => {
        // //console.log(v1, v2, v3)
        return <><div variant={"titleMedium"} style={{ backgroundColor: "#DCDCDC", width: 60, borderWidth: 1, borderStyle: "solid", textAlign: "center", fontWeight: "900" }}>{v1}</div>
            <div variant={"titleMedium"} style={{
                backgroundColor: "#DCDCDC",
                width: 55, borderWidth: 1, borderStyle: "solid", textAlign: "center", fontWeight: "900"
            }}>{v2}</div>
            <div variant={"titleMedium"} style={{ backgroundColor: "#DCDCDC", width: 55, borderWidth: 1, borderStyle: "solid", textAlign: "center", fontWeight: "900" }}>{v3}</div></>
    }
    const t = useTheme()
    return <View>
        <View style={{ flexDirection: "row", alignItems: "center", justifyContent: "center", alignSelf: "flex-start" }}>
            {/* <IconButton icon={"arrow-left"} onPress={() => navigation.goBack()} /> */}
            <ReactToPrint
                pageStyle={pageStyle}
                trigger={() => <div style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: t.colors.primary, color: t.colors.onPrimary, padding: 5, borderRadius: 5, paddingRight: 10 }}><MaterialIcons style={{ marginLeft: 5, marginRight: 5 }} name="print" color={t.colors.onPrimary} />Print</div>}
                content={() => ref.current}
            />
            {pref?.current.supervisor == true && <Button onPress={() => {
                try {
                    const workbook = XLSX.utils.book_new();
                    const headers = ["રોલ", "GR", "વિદ્યાર્થી નું નામ"]
                    value.subjects.map(s => headers.push(s.name))
                    headers.push("પરિણામ")
                    headers.push("મેળવેલ ગુણ")
                    headers.push("Rank")
                    const l2: [] = []
                    value?.sheet?.filter(e => e?.totalling !== true)?.map(s => {
                        const me = { "roll": s.student["class" + value.year]?.roll, gr: s.student["class" + value.year]?.gr, name: s.student.name + (Global.isLeft(s.student, value.year) ? "(Left)" : "") }
                        value.subjects.map(e => {
                            const vv = s.subject.find(f => f?.subject_id == e.id)
                            if (vv) {
                                me[e.name] = Global.getValue(vv, "Ab")
                            } else {
                                me[e.name] = ""
                            }
                        }
                        )
                        me.status = Global.isLeft(s.student, value.year) ? "Left" : Global.getResultStatus(s.examObject.status)
                        me.marks = s.examObject.subjectMarks
                        me.rank = s.examObject.rank ? s.examObject.rank : ""
                        l2.push(me)
                    })
                    const worksheet = XLSX.utils.json_to_sheet(l2)
                    //console.log(l2)
                    XLSX.utils.book_append_sheet(workbook, worksheet, "SummarySheet");
                    XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: "A1" });
                    XLSX.writeFile(workbook, "SummarySheet" + value.class.name + (value.class.div ? " " + value.class.div : "") + ".xlsx");
                } catch (e) {
                    //console.log("me the e", e)
                    alert("error")
                }
            }}>Export</Button>}
        </View>
        <View>
            <div ref={ref} style={{ display: "block", width: "98%", marginLeft: 10, boxSizing: "border-box" }}>
                {value.tarij == 1 ? <style type="text/css" media="print">{"@page { size: landscape, margin: 25mm 25mm 25mm 25mm}"}</style> :
                    <style type="text/css" media="print">{"@page { size: portrait}"}</style>
                }
                {value.tarij == 0 &&
                    <div style={{ marginLeft: 100, display: "block", marginRight: 30 }}>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <Text variant="displaySmall" style={{ fontWeight: "bold", textAlign: "center", flex: 1, marginTop: 20, }}>{"શ્રી ઠક્કરબાપા વિદ્યામંદિર"}</Text>
                            <Text style={{ flex: 1, padding: 10, backgroundColor: "green", color: "white", textAlign: "center" }} variant="titleLarge">પરિણામ પત્રક - {value.exam?.name}</Text>
                            <View style={{ flexDirection: "row" }}>
                                <View style={{ flex: 1, alignItems: "center", justifyContent: "center", borderWidth: 1, }}>
                                    <Text variant="titleLarge">{value.class?.name}</Text>
                                </View>
                                {value.class?.div && <View style={{ flex: 1, alignItems: "center", justifyContent: "center", borderWidth: 1, }}>
                                    <Text variant="titleLarge">વર્ગ {value.class?.div}</Text>
                                </View>}
                                <View style={{ flex: 1, alignItems: "center", justifyContent: "center", borderWidth: 1 }}>
                                    <Text variant="titleLarge">વર્ષ {Global.YearString(value.year + "")}</Text>
                                </View>
                            </View>
                            <View style={{ padding: 2, borderWidth: 2, marginTop: 20 }}>
                                <View style={{ flex: 1, alignItems: "center", justifyContent: "center", flexDirection: "row", borderWidth: 1, borderStyle: "solid" }}>
                                    <Text style={{ flex: 4, borderRightWidth: 1, borderStyle: "solid" }} variant="titleMedium">વિદ્યાર્થીઓની કુલ સંખ્યા</Text>
                                    <Text style={{ flex: 1, textAlign: "center" }} variant="titleLarge">{(value?.overAll?.total - value.left)}</Text>
                                </View>
                                <View style={{ flex: 1, alignItems: "center", justifyContent: "center", flexDirection: "row", borderWidth: 1, borderStyle: "solid" }}>
                                    <Text style={{ flex: 4, borderRightWidth: 1, borderStyle: "solid" }} variant="titleMedium">પરીક્ષામાં બેઠેલા વિદ્યાર્થીઓની સંખ્યા </Text>
                                    <Text style={{ flex: 1, textAlign: "center" }} variant="titleLarge">{value?.overAll?.attend}</Text>
                                </View>
                                <View style={{ flex: 1, alignItems: "center", justifyContent: "center", flexDirection: "row", borderWidth: 1, borderStyle: "solid" }}>
                                    <Text style={{ flex: 4, borderRightWidth: 1, borderStyle: "solid" }} variant="titleMedium">ઉત્તીર્ણ થનાર વિદ્યાર્થીઓની સંખ્યા </Text>
                                    <Text style={{ flex: 1, textAlign: "center" }} variant="titleLarge">{value?.overAll?.pass}</Text>
                                </View>
                                <View style={{ flex: 1, alignItems: "center", justifyContent: "center", flexDirection: "row", borderWidth: 1, borderStyle: "solid" }}>
                                    <Text style={{ flex: 4, borderRightWidth: 1, borderStyle: "solid" }} variant="titleMedium">નાપાસ થનાર વિદ્યાર્થીઓની સંખ્યા </Text>
                                    <Text style={{ flex: 1, textAlign: "center" }} variant="titleLarge">{value?.overAll?.fail}</Text>
                                </View>
                                <View style={{ flex: 1, alignItems: "center", justifyContent: "center", flexDirection: "row", borderWidth: 1, borderStyle: "solid" }}>
                                    <Text style={{ flex: 4, borderRightWidth: 1, borderStyle: "solid" }} variant="titleMedium">વિદ્યાર્થીઓની કુલ સંખ્યા પર પરિણામના ટકા </Text>
                                    <Text style={{ flex: 1, textAlign: "center" }} variant="titleLarge">{Math.round((value?.overAll?.pass * 100) / (value?.overAll?.total - value.left))}%</Text>
                                </View>

                                <View style={{ flex: 1, alignItems: "center", justifyContent: "center", flexDirection: "row", borderWidth: 1, borderStyle: "solid" }}>
                                    <Text style={{ flex: 4, borderRightWidth: 1, borderStyle: "solid" }} variant="titleMedium">પરીક્ષામાં બેઠેલ વિદ્યાર્થીઓની સંખ્યા પર પરિણામના ટકા</Text>
                                    <Text style={{ flex: 1, textAlign: "center" }} variant="titleLarge">{Math.round((value.overAll?.pass * 100) / value.overAll?.attend)}%</Text>
                                </View>
                            </View>
                            <View style={{ flexDirection: "row", marginTop: 30, flex: 1, alignSelf: "stretch" }}>
                                <View style={{ alignItems: "center", justifyContent: "center", flex: 1, alignSelf: "stretch" }}>
                                    <View style={{ flexDirection: "row", alignSelf: "stretch", borderWidth: 1, borderStyle: "solid", backgroundColor: "#DCDCDC" }}>
                                        <Text style={{ flex: 150, flexShrink: 0, textAlign: "center", borderRightWidth: 1 }}>વિષય </Text>
                                        <Text style={{ flex: 150, textAlign: "center", borderRightWidth: 1 }}>વિષયશિક્ષક</Text>
                                        <Text style={{ flex: 100, textAlign: "center", borderRightWidth: 1 }}>પરીક્ષામાં બેઠેલ સંખ્યા</Text>
                                        <Text style={{ flex: 100, textAlign: "center", borderRightWidth: 1 }}>ઉતીર્ણ સંખ્યા</Text>
                                        <Text style={{ flex: 50, textAlign: "center" }}>ટકાવારી</Text>
                                    </View>
                                    <View style={{ alignSelf: "stretch", flex: 1 }}>
                                        {
                                            value.subjects.map(s => {
                                                const rx = Math.round((s.pass * 100) / s.attend)
                                                let rs
                                                if (isNaN(rx)) {
                                                    rs = ""
                                                } else {
                                                    rs = rx
                                                }
                                                return <View style={{ borderWidth: 1, flexDirection: "row", alignSelf: "stretch", borderStyle: "solid" }}>
                                                    <Text style={{ flexShrink: 0, flex: 150, borderRightWidth: 1 }}>{s.name}</Text>
                                                    <Text style={{ flex: 150, borderRightWidth: 1 }}>{s?.teacher?.teacherName}</Text>
                                                    <Text style={{ flex: 100, textAlign: "center", borderRightWidth: 1 }}>{s.attend}</Text>
                                                    <Text style={{ flex: 100, textAlign: "center", borderRightWidth: 1 }}>{s.pass}</Text>
                                                    <Text style={{ flex: 50, textAlign: "center" }}>{rs} {rs ? "%" : ""}</Text>
                                                </View>
                                            })
                                        }
                                    </View>
                                </View>
                            </View>
                            <View style={{ alignItems: "center", justifyContent: "center", marginTop: 30 }}>
                                <View style={{ flexDirection: "row", alignSelf: "stretch", borderWidth: 1, borderStyle: "solid", backgroundColor: "#DCDCDC" }}>
                                    <Text style={{ flex: 50, textAlign: "center", borderRightWidth: 1 }}>ક્રમાંક નં</Text>
                                    <Text style={{ flex: 50, textAlign: "center", borderRightWidth: 1 }}>રોલ નં</Text>
                                    <Text style={{ flex: 300, textAlign: "center", borderRightWidth: 1 }}>વિદ્યાર્થીનું નામ</Text>
                                    <Text style={{ flex: 80, textAlign: "center", borderRightWidth: 1 }}>મેળવેલ ગુણ</Text>
                                    <Text style={{ flex: 80, textAlign: "center" }}>ટકાવારી (%)</Text>
                                </View>
                                <View style={{ alignSelf: "stretch", flex: 1 }}>
                                    {
                                        value.ranklist.map((s) => {
                                            return <View style={{ borderWidth: 1, flexDirection: "row", alignSelf: "stretch", borderWidth: 1, borderStyle: "solid" }}>
                                                <Text style={{ flex: 50, textAlign: "center", borderRightWidth: 1 }}>{s.Summary?.rank}</Text>
                                                <Text style={{ flex: 50, textAlign: "center", borderRightWidth: 1 }}>{s.Summary.student["class" + value.year]?.roll}</Text>
                                                <Text style={{ flex: 300, borderRightWidth: 1 }}>{s.Summary.student.name}</Text>
                                                <Text style={{ flex: 80, textAlign: "center", borderRightWidth: 1 }}>{s?.Summary?.selfMarks}</Text>
                                                <Text style={{ flex: 80, textAlign: "center" }}>{s?.Summary?.pc} %</Text>
                                            </View>
                                        })
                                    }
                                </View>
                            </View>
                            <View style={{ flexDirection: "row", marginTop: 70 }}>
                                <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
                                    <Text variant="titleLarge" style={{ textAlign: "center" }}>  વર્ગ શિક્ષક  </Text>
                                </View>
                                <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
                                    <Text variant="titleLarge" style={{ textAlign: "center" }}>  તારીખ  </Text>
                                </View>
                                <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
                                    <Text variant="titleLarge" style={{ textAlign: "center" }}>  આચાર્ય  </Text>
                                </View>
                            </View>
                        </div>
                        <div className="pagebreak" />
                    </div>
                }
                {value.tarij == 1 &&
                    <View style={{ paddingLeft: 60 }}>
                        <Text variant="displaySmall" style={{ fontWeight: "bold", flex: 1, textAlign: "center", marginTop: 20, }}>{"શ્રી ઠક્કરબાપા વિદ્યામંદિર"}</Text>
                        <View style={{ flexDirection: "row", }}>
                            <Text variant="titleLarge" style={{ textAlign: "center", flex: 1 }} >Summary Sheet</Text>
                            <Text variant="titleLarge" style={{ textAlign: "center", flex: 1 }} >{value.class?.name} {value.class?.div}</Text>
                            <Text variant="titleLarge" style={{ textAlign: "center", flex: 1 }} >{value.exam?.name} {Global.YearString(value.year)}</Text>
                            {/* <Text variant="titleLarge" style={{ flex: 1, textAlign: "right", paddingRight: 20 }}>{value.class?.name} {value.class?.div}</Text> */}

                        </View>
                    </View>
                }
                {value.tarij == 1 && <View>
                    <table style={{ paddingLeft: 60, width: "100%", paddingRight: 20 }}>
                        <thead style={{ padding: 0, margin: 0 }}>
                            <div style={{ display: "flex", pageBreakInside: "avoid", flexDirection: "row", marginTop: 30 }}>
                                <Row1 roll={"રોલ"} gr={"GR"} name={"વિદ્યાર્થી નું નામ"} title={true} />
                                {
                                    value.subjects.map(e => {
                                        return <Row2 value={e.name} title={true} />
                                    })
                                }
                                <Row3 v1={"પરિણામ"} v2={"મેળવેલ ગુણ"} v3={"Rank"} />
                            </div>
                        </thead>
                        <tbody style={{ padding: 0, margin: 0 }}>
                            {
                                value?.sheet?.filter(e => e?.totalling !== true)?.map(s => {
                                    const stud = s.student?.Summary?.student
                                    const studInfo = s.student?.Summary?.student?.["class" + value.year]
                                    const left = Global.isLeft(stud, value.year)
                                    return <div style={{ display: "flex", pageBreakInside: "avoid", flexDirection: "row" }}>
                                        <Row1 roll={studInfo?.roll} gr={studInfo?.gr} name={stud.name + (left ? "(Left)" : "")} title={false} left={left} />
                                        {
                                            s.subject.map(e => {
                                                const id = Global.genSubId({ studentId: stud.id, classId: studInfo?.classId, examId: value.exam.name, year: value.year, subjectId: e.id })
                                                return <Row2
                                                    value={s.student[id] ? Global.getDoubleZero(Global.getValue(s.student[id], "Ab")) : ""}
                                                    title={false}
                                                    status={left ? "Left" : Global.getResultStatus(s.student[id]?.status)} />
                                            }
                                            )
                                        }
                                        < Row3 v1={left ? "Left" : Global.getResultStatus(s.student?.Summary?.status)} v2={s.student?.Summary?.selfMarks} v3={s.student?.Summary?.rank} />
                                    </div>
                                })

                            }
                        </tbody>
                    </table>
                </View>}
                {value.tarij == 2 && <div style={{ paddingLeft: 80, paddingRight: 40, display: "block" }}>
                    {/* {//console.log("ssss", value)} */}
                    {SummarySheet?.subjectList.map(s => {
                        return <View >
                            {/* <Page s={s} type={s.practical ? 1 : 0} /> */}
                            <Page s={s} />
                            {/* {s.practical && <Page s={s} type={s.practical ? 2 : 0} />} */}
                        </View>
                    })
                    }
                    <div className="pagebreak" />
                </div>}

            </div>

            {/* <Text style={{ flex: 1 }}  >Generated on {dayjs().format("DD/MM/YY HH:mm")}</Text> */}
        </View >
    </View>
}